import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";
import Country from './country';

function PricingCon() {
    const [currency, setCurrency] = useState("");
    const [growthOffer, setGrowthOffer] = useState("");

    // Pricing by region
    const PRICES = {
        KE: {
            monthly: [0, 0, 4999, 14999],
            yearly: [0, 0, 49990, 149990],
            currency: "KES",
            growthOffer: "Custom domain"
        },
        US: {
            monthly: [0, 0, 50, 150],
            yearly: [0, 0, 500, 1500],
            currency: "USD",
            growthOffer: "Custom domain"
        }
    };

    const [plans, setPlans] = useState({
        monthly: [0, 0, 0, 0],
        yearly: [0, 0, 0, 0]
    });

    async function loadPricing() {
        let code = localStorage.getItem("kadhr_country_code");

        if (!code) {
            try {
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();
                code = data.country_code || "KE";
            } catch {
                code = "KE";
            }
            localStorage.setItem("kadhr_country_code", code);
        }

        // Normalize codes
        code = code.toUpperCase();
        if (code === "KES") code = "KE";  // fix the inconsistency

        // Determine region
        const region = code === "KE" ? PRICES.KE : PRICES.US;

        setPlans({
            monthly: region.monthly,
            yearly: region.yearly
        });

        setCurrency(region.currency);
        setGrowthOffer(region.growthOffer);
    }


    useEffect(() => {
        loadPricing();
    }, []);

    return (
        <>
            <div className="col-12 text-center text-white pt-6indx">
                <div className="d-flex justify-content-center mb-3">
                    <div className="col-5 col-lg-2 text-center text-white">
                        <Country />
                    </div>
                </div>

                <h1 className='mb-3 display-6 font-bold fw800'>
                    <b>
                        <span className='text-primary'>Kadhr pays for itself </span><br />
                        <span className='text-dark'> by bringing customers back.</span>
                    </b>
                </h1>

                <p className='mb-4 font1 text-dark'>
                    Start free and upgrade as your repeat customer base grows.
                </p>
            </div>

            <div className="col-12 pt-6indx0 mb-5" id='pricing'>
                <div className='container'>
                    <div className="row d-flex flex-nowrap overflow-auto overflow-lg-visible pb-2 pt-2">

                        {/* PREMIUM PLAN */}
                        <div className="col-10 col-lg-4 col-md-6 col-xs-10 mb-30">
                            <div className="feature-content prc">

                                <span className="yrprc rounded-2 ms-1 savegreen font8">
                                    No monthly commitment
                                </span>

                                <h4 className="pmhd mt-4">PAY AS YOU GO</h4>

                                <p className="text-center font8">
                                    Recharge → bring customers back <br/>→ make money
                                </p>

                                <p className="p-prc mb-5 mt-4">
                                    <span>{currency}.</span>{plans.monthly[1]}<span className='font8'> to start</span>
                                </p>

                                <Link className="main-btn btn-hover border-btn ctabtn mb-4" to="/seller/register">
                                    Get Started
                                </Link>

                                <hr />

                                <ul className="pl-0 font9">
                                    {/* CORE SETUP */}
                                    <li><p>1 User</p></li>
                                    <li><p>Storefront</p></li>
                                    <li><p>Sales & Customer Capture (POS Lite)</p></li>
                                    <li><p>Order & Stock Management</p></li>
                                    <li><p>Up to 100 Products</p></li>
                                    <li><p>Up to 1,000 monthly orders</p></li>

                                    {/* GROWTH & RETENTION */}
                                    <li><p><b>Repeat Revenue Agent</b></p></li>
                                    <li><p>Customer Segmentation</p></li>
                                    <li><p>Omni-channel (SMS)</p></li> 
                                    <li><p>Advanced Insights</p></li>

                                    {/* INTEGRATIONS */}
                                    <li><p>POS, WooCommerce & API Integrations</p></li>

                                    {/* PAYMENTS */}
                                    <li><p>Mobile Money Payments (2%)</p></li>
                                    <li><p>Cards (3–4%)</p></li>

                                    {/* SUPPORT */}
                                    <li><p>Email Support</p></li>
                                </ul>
                            </div>
                        </div>


                        {/* GROWTH PLAN */}
                        <div className="col-10 col-lg-4 col-md-6 col-xs-10 mb-30">
                            <div className="feature-content prc" style={{ border: '5px solid #0070ff' }}>

                                <span className="yrprc rounded-2 ms-1 savegreen font8">
                                    {currency}. {plans.yearly[2].toLocaleString()}/year &nbsp; 2 Months Free
                                </span>

                                <h4 className="pmhd mt-4">GROWTH</h4>

                                <p className="text-center font8">
                                    Automate relationships.<br/> Scale repeat revenue.
                                </p>

                                <p className="p-prc mb-5 mt-4">
                                    <span>{currency}.</span>{plans.monthly[2]}<span>/mo</span>
                                </p>
                                
                                <Link className="main-btn btn-hover bg-blue text-white border-btn mb-4 ctabtn" to="/seller/register">
                                    Scale with Growth
                                </Link>

                                <hr />

                                <ul className="pl-0 font9">
                                    <li><p><b>Everything in Pay As You Go</b></p></li>
                                    <li><p>Up to 4 staff accounts</p></li>
                                    <li><p>Unlimited Products</p></li>
                                    <li><p>Unlimited monthly orders</p></li>
                                    <li><p><b>Advanced Repeat Revenue Agent</b></p></li>                                    
                                    <li><p>Advanced segmentation (RFM, behavior)</p></li>          
                                    <li><p>Advanced analytics (LTV, churn, cohorts)</p></li>  
                                    <li><p>Multi-channel (WhatsApp, SMS)</p></li> 
                                    <li><p>Advanced relationship insights</p></li>
                                    <li><p>Mæven Assistant</p></li>
                                    <li><p>400 SMS Credits</p></li>
                                    <li><p>Priority Support</p></li>
                                </ul>
                            </div>
                        </div>


                        {/* ENTERPRISE PLAN */}
                        <div className="col-10 col-lg-4 col-md-6 col-xs-10 mb-30">
                            <div className="feature-content prc ent text-white bg-dark">

                                <span className="yrprc rounded-2 ms-1 savegreen font8 bg-dark"></span>

                                <h4 className="pmhd mt-4 text-white text-left">ENTERPRISE</h4>

                                <p className="font8 text-left">
                                    Relationship infrastructure<br/> for commerce platforms.
                                </p>

                                <p className="p-prc mb-5 mt-4 text-white text-left">
                                    <span>Let's talk</span>
                                </p>

                                <Link className="main-btn btn-hover border-btn mb-4 ctabtn text-white border-white" to="mailto:sales@kadhr.com">
                                    Contact Sales
                                </Link>

                                <hr />

                                <ul className="pl-0 font9">
                                    <li><p><b>Everything in Growth</b></p></li>   
                                    <li><p>API access & Webhooks</p></li> 
                                    <li><p>Embedded widgets</p></li> 
                                    <li><p>Data warehouse sync</p></li>                    
                                    <li><p>Custom workflows</p></li>    
                                    <li><p>Unlimited staff accounts</p></li>
                                    <li><p>Account manager</p></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default PricingCon;
